import React from 'react';

const SelectProgrammingLanguage = () => {
  return (
    <div className="programming-language row">
      <nav className="col-lg-6 offset-lg-6 pt-2 pb-2 programming-language__header">
        <ul className="nav nav-pills">
          <li className="nav-item">
            <a className="nav-link active" href="#">cURL</a>
          </li>
          {/* <li className="nav-item">
            <a className="nav-link disabled" href="#">Node</a>
          </li>
          <li className="nav-item">
            <a className="nav-link disabled" href="#">C#</a>
          </li>
          <li className="nav-item">
            <a className="nav-link disabled" href="#">Java</a>
          </li> */}
        </ul>
      </nav>
    </div>
  );
}

export default SelectProgrammingLanguage;



// WEBPACK FOOTER //
// ./src/components/SelectProgrammingLanguage.js